// eslint-disable-next-line import/prefer-default-export
export const XLSX_COL_MARGIN = 2;
export const MAX_ROWS_COUNT = 10000000;
export const FLOWIO_LINK_ID = "flowio-link:";
export const FLOWIO_NUMBER_ID = "flowio-number:";
export const FLOWIO_DATE_ID = "flowio-date:";
export const TABLE_EXPORT_FORM_ID = "table-export-form";
export const EMPTY_TABLE_COLS = 1;
export const EMPTY_TABLE_ROWS = 3;
export const DATE_FORMAT = "dd_MM_yyyy";
export const EMPTY_TABLE_CELL = " ";
export const PDF_PAGE_A4 = "A4";

export const MAX_PDF_COLS = 8;
